/* eslint-disable no-unused-vars */
export enum AnnouncementAudienceEnum {
    /** Shown to everyone, including visitors that are not logged in (e.g. on the login page). */
    ALL = 'all',
    /** Shown to logged in users only. */
    AUTHENTICATED = 'authenticated',
}
